import React from "react";
import "./intro.css";
import backgroundImage from "../../assets/website_jake.jpg";



const Intro = () => {
    return (
        <section id="intro">
            <div className="introContent">
                <span className="welcome">
                    Welcome,
                </span>
                <span className="introText">
                    I'm <span className="introName">Jake Malegni</span>,
                    <br />
                    Computer Engineering
                    <br />
                    Student
                </span>
                <p className="introParagraph">
                    Currently studying at the University of Florida.
                    <br/>
                    Field Applications Engineer at Astera Labs 2026
                </p>
            </div>
            <img src={backgroundImage} alt="Joseph at Osaka Castle" className="bg" />
        </section>
    );
}

export default Intro;
